var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: ["sub-values"] }, [
    _vm.data && _vm.data.text
      ? _c(
          "div",
          {
            staticClass: "sub-value clickable",
            on: {
              click: function($event) {
                return _vm.$emit("click")
              }
            }
          },
          [_c("div", { domProps: { innerHTML: _vm._s(_vm.data.text) } })]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }